export function getIntegerPart(number: number | string) {
    number = String(number).replace(/,/g, '');
    return parseInt(String(number));
}

export function getDecimalPart(number: number | string) {
    number = String(number).replace(/,/g, '');
    return Number(number).toFixed(2).split('.')[1];
}

export function getCommaSeparatedNumber(
    number: number | string,
    options?: Intl.NumberFormatOptions,
) {
    number = String(number).replace(/,/g, '');
    return Number(number).toLocaleString(undefined, options);
}

export function parseNumber(number: number | string) {
    number = String(number).replace(/,/g, '');
    return Number(number);
}

export function symbolizedNumber(
    value: number,
    precision = 2,
    removeTrailingZeros = true,
) {
    const scales = [
        { threshold: 1_000_000_000, suffix: 'B' },
        { threshold: 1_000_000, suffix: 'M' },
        { threshold: 1_000, suffix: 'K' },
        { threshold: 1, suffix: '' },
    ];

    const absValue = Math.abs(value);

    for (const { threshold, suffix } of scales) {
        if (absValue >= threshold) {
            let truncatedValue = (value / threshold).toFixed(precision);
            if (removeTrailingZeros) {
                truncatedValue = `${Number(truncatedValue)}`;
            }
            return `${truncatedValue}${suffix}`;
        }
    }

    return value.toString();
}
